import { datesMessageGlobal } from "../../lib/dateScripts";
import { formatDateLocal } from "../../lib/script";
import BodySimpleModalV3 from "./modal/BodySimpleModalV3";

export default function DateDisplayWithModal({date}) {
    return <BodySimpleModalV3 normalEvent={true} message={datesMessageGlobal(date)} disabled={!date}>
        {formatDateLocal(date)}
    </BodySimpleModalV3> 
}